import { storage } from "../storage/storage";

const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";

let accessToken: string | null = null;
let refreshToken: string | null = null;

export const tokenManager = {
    getAccessToken(): string | null {
        return accessToken ?? storage.get<string>(ACCESS_TOKEN_KEY);
    },

    getRefreshToken(): string | null {
        return refreshToken ?? storage.get<string>(REFRESH_TOKEN_KEY);
    },

    setTokens(access: string, refresh: string): void {
        accessToken = access;
        refreshToken = refresh;
        storage.set(ACCESS_TOKEN_KEY, access);
        storage.set(REFRESH_TOKEN_KEY, refresh);
    },

    clearTokens(): void {
        accessToken = null;
        refreshToken = null;
        storage.remove(ACCESS_TOKEN_KEY);
        storage.remove(REFRESH_TOKEN_KEY);
    },
};
